import { render } from "./AddressForm.vue?vue&type=template&id=7c5db694"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__